/** Linear interpolated percentiles of finite observations; missing athletes are not zero. */
export function cohortQuartiles(values: number[]): { low: number; median: number; high: number } | null {
  const v = values.filter(Number.isFinite).sort((a,b)=>a-b);
  if (v.length < 2) return null;
  const q = (fraction: number) => { const i=(v.length-1)*fraction, lo=Math.floor(i); return v[lo]+(v[Math.ceil(i)]-v[lo])*(i-lo); };
  return { low:q(.25), median:q(.5), high:q(.75) };
}
